import * as React from 'react'

import { Colors, Table } from '@factorialco/deprecated-design-system'

interface Props {
  selected: boolean
  background: Colors
  to: string
  children: React.ReactNode
}

const Row = ({ selected, background, to, children }: Props) => {
  return selected ? (
    <Table.Row background={background}>{children}</Table.Row>
  ) : (
    <Table.Row.Router to={to}>{children}</Table.Row.Router>
  )
}

export default Row
